import TextField from "../TextField";
import styles from "../index.module.scss";

interface AddressFormProps {
    address: {
        street: string;
        city: string;
        zip: string;
        state: string;
        country: string;
    };
    handleChange: (name: string, value: any) => void;
}

const AddressForm = ({ address, handleChange }: AddressFormProps) => {
    const { street, city, zip, state, country } = address;

    const handleAddressChange = (name: string, value: any) => {
        const updatedAddress = { ...address, [name]: value };
        handleChange("address", updatedAddress);
    }
    return (
        <>
            <div className={styles.inputContainer}>
                <TextField
                    name="street"
                    inputValue={street}
                    inputLabel="Street"
                    onChange={handleAddressChange}
                />
                <TextField
                    name="city"
                    inputValue={city}
                    inputLabel="City"
                    onChange={handleAddressChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <TextField
                    name="zip"
                    inputValue={zip}
                    inputLabel="ZIP Code"
                    onChange={handleAddressChange}
                />
                <TextField
                    name="state"
                    inputValue={state}
                    inputLabel="State"
                    onChange={handleAddressChange}
                />
                <TextField
                    name="country"
                    inputValue={country}
                    inputLabel="Country"
                    onChange={handleAddressChange}
                />
            </div>
        </>
    );
}

export default AddressForm;
